import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ReleaseHost } from "./components/ReleaseHost";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ReleaseHost><App /></ReleaseHost>
  </React.StrictMode>,
);
